import { useCallback, useEffect, useRef, useState } from "react";
import s from "../clinic.module.css";

export default function SwipeCarousel({
  items,
  getKey,
  renderSlide,
  hint = "Листайте",
  ariaLabel = "Карусель",
}) {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);

  const syncIndex = useCallback(() => {
    const el = trackRef.current;
    if (!el || !items.length) return;
    const w = el.clientWidth || 1;
    const next = Math.round(el.scrollLeft / w);
    setIndex(Math.max(0, Math.min(next, items.length - 1)));
  }, [items.length]);

  useEffect(() => {
    syncIndex();
  }, [items, syncIndex]);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return undefined;
    el.addEventListener("scroll", syncIndex, { passive: true });
    return () => el.removeEventListener("scroll", syncIndex);
  }, [syncIndex]);

  const goTo = (i) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollTo({ left: i * el.clientWidth, behavior: "smooth" });
    setIndex(i);
  };

  if (!items.length) return null;

  if (items.length === 1) {
    return <div className={s.swipeCarouselSingle}>{renderSlide(items[0], 0)}</div>;
  }

  return (
    <div className={s.swipeCarousel} aria-label={ariaLabel}>
      <div className={s.swipeCarouselMeta}>
        <span className={s.swipeCarouselHint}>{hint}</span>
        <div className={s.swipeCarouselDots} role="tablist" aria-label="Слайды">
          {items.map((item, i) => (
            <button
              key={getKey(item, i)}
              type="button"
              role="tab"
              aria-selected={i === index}
              aria-label={`${i + 1} из ${items.length}`}
              className={
                i === index
                  ? `${s.swipeCarouselDot} ${s.swipeCarouselDotOn}`
                  : s.swipeCarouselDot
              }
              onClick={() => goTo(i)}
            />
          ))}
        </div>
        <span className={s.swipeCarouselCounter}>
          {index + 1}/{items.length}
        </span>
      </div>
      <div className={s.swipeCarouselTrack} ref={trackRef}>
        {items.map((item, i) => (
          <div key={getKey(item, i)} className={s.swipeCarouselSlide}>
            {renderSlide(item, i)}
          </div>
        ))}
      </div>
    </div>
  );
}
